export default __webpack_public_path__ + "static/media/nfllogo.08c6bfa4.png";